/* tslint:disable */
/* eslint-disable */
export enum VisoidImageStatus {
    Complete = 'complete',
    Failed = 'failed',
    Initialized = 'initialized',
    Rendering = 'rendering',
    Source = 'source'
}
